import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { apiClient } from "../lib/api";

const AdminAuthContext = createContext(null);
const TOKEN_KEY = "alta_admin_token";

// A separate axios header to avoid clashing with clinic token.
// Admin endpoints require Authorization: Bearer, so we swap in on request.
export function AdminAuthProvider({ children }) {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState(() => localStorage.getItem(TOKEN_KEY) || "");

  const withAuth = useCallback((cfg = {}) => {
    const t = localStorage.getItem(TOKEN_KEY);
    return { ...cfg, headers: { ...(cfg.headers || {}), Authorization: `Bearer ${t}` } };
  }, []);

  useEffect(() => {
    if (!token) { setLoading(false); return; }
    apiClient.get("/admin/auth/me", withAuth())
      .then((r) => setAdmin(r.data))
      .catch(() => { localStorage.removeItem(TOKEN_KEY); setToken(""); })
      .finally(() => setLoading(false));
  }, [token, withAuth]);

  const login = async (email, password) => {
    const { data } = await apiClient.post("/admin/auth/login", { email, password });
    localStorage.setItem(TOKEN_KEY, data.token);
    setToken(data.token);
    setAdmin(data.admin);
    return data.admin;
  };

  const logout = () => {
    localStorage.removeItem(TOKEN_KEY);
    setToken("");
    setAdmin(null);
  };

  return (
    <AdminAuthContext.Provider value={{ admin, loading, login, logout, withAuth }}>
      {children}
    </AdminAuthContext.Provider>
  );
}

export const useAdminAuth = () => useContext(AdminAuthContext);
